<template>
  <div>
    <div id="printCons">
      <div style="text-align: center; font-size: 18px; margin: 10px 0">
        作者稿费登记表
      </div>
      <div style="text-align: center; font-size: 16px">
        {{
          `${publishRecord.sectionInfo}${publishRecord.year}年总第${publishRecord.total}期`
        }}
      </div>
      <div style="margin-top: 10px; width: 100%">
        <table
          class="p_table"
          style="
            width: 100%;
            border-spacing: 0;
            border-collapse: collapse;
            font-size: 14px;
          "
        >
          <thead>
            <tr
              style="
                page-break-inside: avoid;
                page-break-after: auto;
                height: 30px;
              "
            >
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 35px;
                  line-height: 1;
                "
              >
                序号
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 40px;
                  line-height: 1;
                "
              >
                姓名
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 182px;
                  line-height: 1;
                "
              >
                单位
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 182px;
                  line-height: 1;
                "
              >
                开户行
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 115px;
                  line-height: 1;
                "
              >
                账号
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 90px;
                  line-height: 1;
                "
              >
                行号
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 110px;
                  line-height: 1;
                "
              >
                身份证号
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 70px;
                  line-height: 1;
                "
              >
                电话
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 183px;
                  line-height: 1;
                "
              >
                题目
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 40px;
                  line-height: 1;
                "
              >
                责编
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 40px;
                  line-height: 1;
                "
              >
                字数
              </th>
              <th
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  width: 65px;
                  line-height: 1;
                "
              >
                稿费（{{ royaltiesThousand }}元/千字）
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="
                page-break-inside: avoid;
                page-break-after: auto;
                height: 30px;
              "
              v-for="(item, index) in publishRoyaltiesList"
              :key="item.id"
            >
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ index + 1 }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.authorName }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.companyName }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.openBank }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.bankCard }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.bankCode }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.idCard }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.telephone }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.title }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.editor }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.wordCount }}
              </td>
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
              >
                {{ item.royalties }}
              </td>
            </tr>
            <tr
              style="
                page-break-inside: avoid;
                page-break-after: auto;
                height: 30px;
              "
            >
              <td
                style="
                  border: 1px solid #000;
                  text-align: center;
                  padding: 2px;
                  font-size: 10px;
                  line-height: 1;
                "
                colspan="12"
              >
                合计：{{ totalRoyalties.toFixed(2) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="p_footer" style="height: 18px; margin-top: 10px">
        <template>
          <span style="display: inline-block; font-size: 12px; width: 20%">
            主管院领导：
          </span>
          <span style="display: inline-block; font-size: 12px; width: 20%">
            编辑部主任：
          </span>
          <span style="display: inline-block; font-size: 12px; width: 20%">
            审核：
          </span>
          <span style="display: inline-block; font-size: 12px; width: 20%">
            制表：
          </span>
          <span style="display: inline-block; font-size: 12px; width: 20%">
            年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日
          </span>
        </template>
      </div>
    </div>
    <div style="text-align: right; margin: 24px">
      <a-button
        id="no-print2"
        type="primary"
        @click="toDownload"
        style="margin-left: 10px"
        >下载</a-button
      >
      <a-button
        id="no-print"
        type="primary"
        @click="toPrint"
        style="margin-left: 10px"
        >打印</a-button
      >
    </div>
  </div>
</template>

<script>
import printJS from "print-js";
export default {
  props: {
    publishRecord: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      publishRoyaltiesList: [],
      royaltiesThousand: null,
      totalRoyalties: 0,
    };
  },
  mounted() {
    this.getPublishRoyaltiesList();
  },
  methods: {
    getPublishRoyaltiesList() {
      this.axios
        .get("/publishInfo/queryRoyaltiesList", {
          params: {
            publishCode: this.publishRecord.publishCode,
            time: new Date().getTime(),
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.publishRoyaltiesList = res.data.data;
            if (this.publishRoyaltiesList.length == 0) {
              this.createRoylties();
            } else {
              this.totalRoyalties = this.publishRoyaltiesList.reduce(
                (total, item) => {
                  return total + item.royalties;
                },
                0
              );
              this.royaltiesThousand =
                this.publishRoyaltiesList[0].royaltiesThousand;
            }
          } else {
            this.utils.messageInfo(this, "error", "查询稿费列表失败！");
          }
        });
    },
    createRoylties() {
      let _this = this;
      this.$confirm({
        title: "生成稿费列表",
        content: (h) => {
          return h("a-input", {
            attrs: {
              placeholder: "请输入每千字稿费金额",
              value: _this.royaltiesThousand,
            },
            on: {
              input: (e) =>
                (_this.royaltiesThousand = e.target.value.replace(
                  /[^0-9.]/g,
                  ""
                )),
            },
          });
        },
        onOk: () => {
          if (this.royaltiesThousand == null || this.royaltiesThousand == "") {
            this.utils.messageInfo(this, "error", "请输入每千字稿费金额");
            return new Promise((resolve, reject) => {
              reject();
            });
          }
          this.axios
            .get("/publishInfo/createRoyaltiesList", {
              params: {
                publishCode: this.publishRecord.publishCode,
                royaltiesThousand: this.royaltiesThousand,
              },
            })
            .then((res) => {
              if (res.data.code == "OK") {
                this.utils.messageInfo(this, "success", "生成稿费列表成功");
                this.getPublishRoyaltiesList();
                this.royaltiesThousand = null;
              } else {
                this.utils.messageInfo(this, "error", "生成稿费列表失败");
              }
            });
        },
        onCancel() {},
      });
    },
    toPrint() {
      this.$nextTick(() => {
        printJS({
          printable: "printCons",
          type: "html",
          scanStyles: false,
          style: "@page {margin: 5mm 5mm 5mm 5mm;}",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "no-print2"],
          onPrintDialogClose: function () {
          },
        });
      });
    },
    toDownload() {
      // let printDoc = document.getElementById("printCons");
      this.axios
        .post(
          "/publishInfo/downloadRoyaltiesList",
          {
            publishCode: this.publishRecord.publishCode,
          },
          { params: {}, responseType: "blob" }
        )
        .then((res) => {
          let fileName = res.headers["content-disposition"];
          fileName = fileName.substring(fileName.indexOf("=") + 1);
          let blob = new Blob([res.data], { type: "application/vnd.ms-word" });
          if ("download" in document.createElement("a")) {
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        });
    },
  },
};
</script>

<style>
@page {
  margin: 5mm 5mm 5mm 5mm;
}
</style>